module.exports = "/_next/static/images/OgFunctions-b653561aaf844eaebe8f575627b281f7.png";